<template>
    <!-- <div class="select-input"> -->
    <el-select v-model="select" :multiple="multiple" :placeholder="placeholder" style="width: 100%" clearable filterable
        :size="size" @change="loadSearch">
        <el-option v-for="item in options" :key="item[value]" :label="item[label]" :value="item[value]">
        </el-option>
    </el-select>
    <!-- </div> -->
</template>

<script>
export default {
    name: 'SelectInput',
    props: {
        placeholder: {
            type: String,
            default: '请选择'
        },
        size: {
            type: String,
            default: 'mini'
        },
        options: {
            type: Array,
        },
        value: {
            type: String,
            default: 'id'
        },
        label: {
            type: String,
        },
        controller: {
            type: String,
        },
        method: {
            type: String
        },
        loadingClose: {
            type: Boolean,
            default: true
        },
        host: {
            type: String,
            default: ''
        },
        multiple: {
            type: Boolean,
            default: true
        },
        choosed: {
            type: [Array, String, Number],
        }
    },
    data() {
        return {
            select: null,
        }
    },
    methods: {
        // loadSearch(search) {
        //     this.$axios.get(`${this.host}api/api3_common_select_search`,{
        //         loadingClose: this.loadingClose,
        //         params: {
        //             search,
        //             controller: this.controller,
        //             method: this.method
        //         }
        //     }).then(({data}) => {
        //         if (data.code === 0) {

        //         }
        //     }).catch()
        // }
        loadSearch() {
            this.$emit('createSearch', this.select)
        }
    },
    watch: {
        choosed: {
            immediate: true,
            handler(n) {
                this.select = n
            }
        },
        options: {
            immediate: true,
            handler(n) {
                this.options = n
            }
        },

    }
}
</script>


// WEBPACK FOOTER //
// src/commonReform/SelectInput.vue